'use strict';

angular.module('shiftTraderApp')
    .directive('saDaysOffManagementGuideBar', ['TimeService', 'DaysOffManagementModalService', '$compile', '$q', 'DayOffLimitStore', 'Session', 'ViewDayOffDayHistoryModalService',
    function (TimeService, DaysOffManagementModalService, $compile, $q, DayOffLimitStore, Session, ViewDayOffDayHistoryModalService) {
      var dayTemplate = '' +
        '<div class="guide-bar-day" data-ng-class="::guideBarDays[dayNum]._cssClasses" data-ng-click="changeDate(guideBarDays[dayNum].dayTwix.start)">' +
          '<div class="guide-bar-day-inner">' +
            '<div class="status-color-bar"></div>' +
            '<div class="date-container clearfix">' +
              '<div class="day" data-ng-bind="::guideBarDays[dayNum].dayTwix.start.format(\'ddd\')"></div>' +
              '<div class="month-date" data-ng-bind="::guideBarDays[dayNum].dayTwix.start.format(\'MM/DD\')"></div>' +
            '</div>' +
            '<div class="status-badge-container">' +
              '<div class="status-badge pending" data-ng-if="::guideBarDays[dayNum]._stats.numPending > 0">{{::guideBarDays[dayNum]._stats.numPending}} PENDING</div>' +
              '<div class="status-badge approved" data-ng-if="::guideBarDays[dayNum]._stats.numPending === 0">{{::guideBarDays[dayNum]._stats.numApproved}} APPROVED</div>' +
            '</div>' +
          '</div>' +
        '</div>';

      var compileGuideBarDayTemplate = function(scope, dayNum) {
        return $compile(dayTemplate.replace(/dayNum/gm, dayNum))(scope);
      };


      return {
        templateUrl: 'views/daysOff/saDaysOffManagementGuideBar.html',
        restrict: 'A',
        scope: {
          departments: '='
        },
        controllerAs: 'guideBarCtrl',
        controller: ['$scope', 'DaysOffManagementModalService', function($scope, DaysOffManagementModalService) {
          var vm = this;
          console.log('ctrl init');

          $scope.changeDate = function(dt) {
            console.log('changeDate in guideBar', dt.format());
            DaysOffManagementModalService.setCurrentDate(dt);
          };

        }],
        link: function(scope, elem) {
          scope.state = {
            selectedDayNum: -1
          };

          var limitsByDay = [null, null, null, null, null, null, null];

          var guideBarDaysContainer = $($(elem).find('.guide-bar-days-container')[0]);

          function setClasses(guideBarDay) {

            var numApprovedAndPending = guideBarDay._stats.numPending + guideBarDay._stats.numApproved;

            guideBarDay._cssClasses = {
              selected: guideBarDay._selected,
              'has-limit-set': guideBarDay._stats.limitRecord,
              'no-requests-yet': numApprovedAndPending > 0,
              'has-pending': guideBarDay._stats.numPending > 0,
              'limit-at-risk': guideBarDay._stats.limitRecord && (numApprovedAndPending > guideBarDay._stats.limitRecord.limit),
              'over-limit': guideBarDay._stats.limitRecord && (guideBarDay._stats.numApproved > guideBarDay._stats.limitRecord.limit),
              'under-limit': guideBarDay._stats.limitRecord && (numApprovedAndPending < guideBarDay._stats.limitRecord.limit),
              'at-limit': guideBarDay._stats.limitRecord && (numApprovedAndPending === guideBarDay._stats.limitRecord.limit)
            };

            // is limitRecord === null then there isn't a limit for this date
            if (_.isNull(guideBarDay._stats.limitRecord)) {
              guideBarDay._cssClasses['no-limit-set'] = true;
            }
          }

          function updateDepartmentsPopoverData() {
            scope.departmentsData = _.map(scope.departments, function(dept) {
              var gbd = scope.guideBarDays[scope.state.selectedDayNum];

              var daysOff = _.where(gbd.daysOff, function(dayOff) {
                var hasDeptMetadata = dayOff.user.metadata && dayOff.user.metadata.department_ids_by_org &&
                  dayOff.user.metadata.department_ids_by_org.data && dayOff.user.metadata.department_ids_by_org.data[dayOff.organization_id]
                  && dayOff.user.metadata.department_ids_by_org.data[dayOff.organization_id].length > 0;

                return hasDeptMetadata &&
                  _.contains(dayOff.user.metadata.department_ids_by_org.data[dayOff.organization_id], dept.id);
              });


              var numPending = _.where(daysOff, function(dayOff) {
                return dayOff.$isPending()
              }).length;

              var numApproved = _.where(daysOff, function(dayOff) {
                return dayOff.$isApproved();
              }).length;

              var numDisapproved = _.where(daysOff, function(dayOff) {
                return dayOff.$isDisapproved();
              }).length;

              return {
                dept: dept,
                daysOff: gbd.daysOff,
                numPending: numPending,
                numApproved: numApproved,
                numDisapproved: numDisapproved
              };
            });

            DaysOffManagementModalService.setDepartmentsSummaryData(scope.departmentsData);
          }

          function updateGuideBar() {
            var currentDate = DaysOffManagementModalService.getCurrentDate();
            var currentWeekDayTwixes = DaysOffManagementModalService.getCurrentWeekDayTwixes();

            $q.all(_.map(currentWeekDayTwixes, function(dayTwix) {
              return DayOffLimitStore.getLimitForDate(dayTwix.start);
            }))
              .then(function(resultingLimitsByDay) {
                limitsByDay = resultingLimitsByDay;

                if (scope.guideBarDays) {
                  _.each(scope.guideBarDays, function(gbd, idx) {
                    gbd._stats.limitRecord = limitsByDay[idx];
                    setClasses(gbd);
                  });

                  guideBarDaysContainer.empty();
                  _.each(scope.guideBarDays, function(x, idx) {
                    guideBarDaysContainer.append(compileGuideBarDayTemplate(scope, idx));
                  });
                }
              });


            $q.all(_.map(currentWeekDayTwixes, function(dayTwix) {
              return DaysOffManagementModalService.getDaysOffIntersectingDate(dayTwix.start);
            }))
              .then(function(data) {
                var workDayStartHour = Session.getWorkDayStartHour();

                scope.guideBarDays = _.map(currentWeekDayTwixes, function(dayTwix, idx) {
                  var temp = {
                    index: idx,
                    dayTwix: dayTwix,
                    dayOfWeek: dayTwix.start.day(),
                    daysOff: _.where(data[idx], function(dayOff) {
                      var isMultiDayRequest = dayOff.range_twix.start.dayOfYear() !== dayOff.range_twix.end.dayOfYear();
                      var dtIntersection = dayTwix.overlaps(dayOff.range_twix) ? Math.abs(dayOff.range_twix.intersection(dayTwix).length('minutes')) : 0;

                      // if this is a single day request OR if the request overlaps the day by MORE than dayStartHour hrs, then show it.
                      return !dayOff.$wasCancelledOrRemoved() && ((!isMultiDayRequest && dtIntersection > 0) || (isMultiDayRequest && dtIntersection > ( workDayStartHour * 60)));
                    }),
                    _selected: dayTwix.start.isSame(currentDate, 'minute')
                  };

                  if (temp._selected) {
                    scope.state.selectedDayNum = idx;
                  }

                  temp._stats = {
                    limitRecord: limitsByDay[idx],
                    numPending: _.where(temp.daysOff, function(dayOff) {
                      return dayOff.$isPending();
                    }).length,
                    numApproved: _.where(temp.daysOff, function(dayOff) {
                      return dayOff.$isApproved();
                    }).length,
                    numDisapproved: _.where(temp.daysOff, function(dayOff) {
                      return dayOff.$isDisapproved();
                    }).length
                  };

                  // TODO: get the real limit from the servers!

                  setClasses(temp);

                  return temp;
                });

                guideBarDaysContainer.empty();
                _.each(scope.guideBarDays, function(x, idx) {
                  guideBarDaysContainer.append(compileGuideBarDayTemplate(scope, idx));
                });

                updateDepartmentsPopoverData();

              }, function() {
                console.log('fetch failed');
              });

          }

          scope.changeWeek = function(direction) {
            var currentDate = DaysOffManagementModalService.getCurrentDate();

            if (direction > 0) {
              DaysOffManagementModalService.setCurrentDate(moment(currentDate).add(1, 'weeks'));
            } else {
              DaysOffManagementModalService.setCurrentDate(moment(currentDate).subtract(1, 'weeks'));
            }
          };

          scope.openLimitHistoryModal = function () {
            var currentDate = DaysOffManagementModalService.getCurrentDate();

            ViewDayOffDayHistoryModalService.openModal(currentDate);
          };

          updateGuideBar();

          _([DaysOffManagementModalService.dateChangeEventName,
            DaysOffManagementModalService.dataChangeEventName]).each(function(eventName) {

            scope.$on(eventName, function() {
              updateGuideBar();
            });
          });

          function getDepartmentMode() {
            scope.state.deptMode = DaysOffManagementModalService.getDepartmentMode();
          }

          scope.$on(DaysOffManagementModalService.toggleDepartmentModeEventName, function() {
            getDepartmentMode();
          });

          scope.setDepartmentShow = function(val) {
            DaysOffManagementModalService.setDepartmentMode(!!val);
            getDepartmentMode();
          };

          getDepartmentMode();
        }
      };
    }]);
